import { render, staticRenderFns } from "./MiniPlayer.vue?vue&type=template&id=745aadff&scoped=true&"
import script from "./MiniPlayer.vue?vue&type=script&lang=js&"
export * from "./MiniPlayer.vue?vue&type=script&lang=js&"
import style0 from "./MiniPlayer.vue?vue&type=style&index=0&id=745aadff&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "745aadff",
  null
  
)

export default component.exports